<template>
  <b-card title="AkPos Yapılandırması">
    <b-form-group
      label="Merchant ID (SAFE ID)"
      label-for="akbank_merchant_safe_id"
    >
      <b-form-input
        id="akbank_merchant_safe_id"
        v-model="posConfig.config.akbank_merchant_safe_id"
        placeholder="Merchant ID (SAFE ID)"
      />
    </b-form-group>
    <b-form-group
      label="Terminal (SAFE ID)"
      label-for="akbank_terminal_safe_id"
    >
      <b-form-input
        id="akbank_terminal_safe_id"
        v-model="posConfig.config.akbank_terminal_safe_id"
        placeholder="Terminal (SAFE ID)"
      />
    </b-form-group>
    <b-form-group
      label="Secret Key"
      label-for="akbank_secret_key"
    >
      <b-form-input
        id="akbank_secret_key"
        v-model="posConfig.config.akbank_secret_key"
        placeholder="Secret Key"
      />
    </b-form-group>
    <b-form-group
      label="3D URL"
      label-for="akbank_3d_url"
    >
      <b-form-input
        id="akbank_3d_url"
        v-model="posConfig.config.akbank_3d_url"
        placeholder="3D URL"
      />
    </b-form-group>
    <b-form-group
      label="API URL"
      label-for="akbank_api_url"
    >
      <b-form-input
        id="akbank_api_url"
        v-model="posConfig.config.akbank_api_url"
        placeholder="API URL"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'AkbankConfig',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
  },
}
</script>
<style scoped></style>
